import { render, staticRenderFns } from "./category-form.vue?vue&type=template&id=e1b39fd0"
import script from "./category-form.vue?vue&type=script&lang=js"
export * from "./category-form.vue?vue&type=script&lang=js"
import style0 from "./category-form.vue?vue&type=style&index=0&id=e1b39fd0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports